<template>
  <div slider :class="type">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
    </div>
    <div class="swiper-pagination" v-if="pagination"></div>
    <div class="swiper-navigation" v-if="navigation">
      <a class="swiper-button-prev"></a>
      <a class="swiper-button-next"></a>
    </div>
  </div>
</template>

<style lang="less">
@import "../less/proj";

[slider] { .wh(100%);
  .swiper-slide { .-box; }
  &.popular-category{

  }

  &.main-bottom-banner{
  }
}

@media screen and (max-width: 1440px){
  [slider]{
  }
}


@media screen and (max-width: 1280px) {
  [slider]{
  }
}

@media screen and (max-width: 1000px){
  [slider]{
  }
}

@media screen and (max-width: 768px){
  [slider]{
  }
}

</style>

<script>
import _ from 'lodash';
import Swiper from 'swiper';
import { addClass } from '../utils/index';

export default {
  name: 'Slider',
  props: {
    pagination: { default: true },
    navigation: { default: false },
    option: Object,
    type: String,
  },
  data() {
    return {
      slider: null,
      intervalID: -1,
      opt: null,
    };
  },
  mounted() {
    this.intervalID = setInterval(() => {
      if (_.every(this.$el.querySelectorAll('img'), e => e.complete)) {
        window.clearInterval(this.intervalID);
        this.opt = _.extend({
          loop: true,
        }, this.$props.option);
        if (this.$props.pagination) {
          this.opt.pagination = {
            el: this.$el.querySelector('.swiper-pagination'),
            clickable: true,
          };
        }

        if (this.$el.querySelector('.swiper-wrapper .swiper-slide') === null) {
          _.forEach(this.$el.querySelectorAll('.swiper-wrapper > li'), (e) => {
            addClass(e, 'swiper-slide');
          });
        }

        if (this.$props.navigation) {
          this.opt.navigation = {
            nextEl: this.$el.querySelector('.swiper-button-next'),
            prevEl: this.$el.querySelector('.swiper-button-prev'),
          };
        }

        this.slider = new Swiper(
          this.$el.querySelector('.swiper-container'),
          this.opt,
        );
      }
    }, 30);
  },
  updated() {
    // this.disable();
    // this.enable();
  },
  methods: {
    beforeDestroy() {
      this.slider.destroy();
    },
    stopAuto() {
      this.slider.autoplay.stop();
    },
    startAuto() {
      this.slider.autoplay.start();
    },
    prev() {
      this.slider.slidePrev();
    },
    next() {
      this.slider.slideNext();
    },
    goToSlide(index) {
      this.slider.slideTo(index);
    },
    now() {
      return this.slider ? this.slider.realIndex : 0;
    },
    ratio(value) {
      if (this.slider) {
        this.slider.params.touchRatio = value;
      }
    },
    disable() {
      if (this.slider) {
        this.slider.destroy(true, false);
        this.$el.querySelector('.swiper-wrapper').style.transform = 'none';
      }
    },
    enable() {
      this.slider = new Swiper(
        this.$el.querySelector('.swiper-container'),
        this.opt,
      );
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/Slider.vue